// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveAcademicYearHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AcademicYearDTO from '../models/AcademicYearDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYearId: number;
    academicYear: AcademicYearDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYearId: 0,
            academicYear: null,
        },
        initValues);
    },
    academicYearId: 'academicYearId',
    academicYear: 'academicYear',
}

interface Result extends ResultDTO {
    academicYearId: number;
    academicYear: AcademicYearDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            academicYearId: 0,
            academicYear: null,
        },
        initValues);
    },
    academicYearId: 'academicYearId',
    academicYear: 'academicYear',
}

export { Request, Result };